import { render, staticRenderFns } from "./CategoryIn.vue?vue&type=template&id=2b4d5e48&scoped=true&"
import script from "./CategoryIn.vue?vue&type=script&lang=js&"
export * from "./CategoryIn.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIn.vue?vue&type=style&index=0&id=2b4d5e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d5e48",
  null
  
)

export default component.exports